// components/TripHeader.tsx
import React from "react";
import { DialogTitle, Grid, Tooltip, } from "@mui/material";
import WarningIcon from "@mui/icons-material/Warning";
import { faChevronLeft, faPenToSquare, faXmark } from "@fortawesome/sharp-duotone-light-svg-icons";
import { ButtonWithLabel } from "../metric/Metricstyles";
import { CLEAR_MAP, EDIT_BUTTON_TEXT, VIEW } from "../UserVisibleStrings";
import { setWilmaState, useRiskViewerStateKind } from "../../features/riskViewer/riskViewerSlice";
import { setSelectedTime } from "../../features/surface/surfaceSlice";
import { openTripLibrary } from "../../features/Drawer/drawerSlice";
import { handleDrawerClose } from "../tripSidebar/TripDrawer";
import { useIsMobile } from "../../features/pageWidth/pageWidthSlice";
import { Dispatch } from "@reduxjs/toolkit";
import RenameTripField from "./RenameTripField";
import { getWaypointList } from "../tripSidebar/TripCard";
import { Trip } from "../../generated/gpb/api/route";
import { setOpenroadsVisibilityToFalse } from "../../features/mapDisplay/mapDisplaySlice";

interface TripHeaderProps
{
    tripData: Trip | undefined;
    isAdmin: boolean;
    isMissingRoutes: boolean;
    handleEditClick: () => void;
    dispatch: Dispatch;
    riskViewerStateKind: ReturnType<typeof useRiskViewerStateKind>;
}

const TripHeader: React.FC<TripHeaderProps> = ( {
    tripData,
    isAdmin,
    isMissingRoutes,
    handleEditClick,
    dispatch,
    riskViewerStateKind,
} ) =>
{
    const isMobile = useIsMobile();

    return (
        <DialogTitle
            id = "directions-dialog-title"
            sx = {{ display: "flex", justifyContent: "space-between", alignItems: "center", paddingBottom: "0px" }}
        >
            <Grid container spacing = {2}>
                <Grid item xs = {9} alignContent = "center">
                    <span>Trip Details</span>
                    {isAdmin && isMissingRoutes &&
                    <Tooltip title = "Some variations failed to generate">
                        <WarningIcon style = {{ color: "orange", marginLeft: "8px" }}/>
                    </Tooltip>}
                </Grid>
                <Grid item xs = {1}>
                    <ButtonWithLabel onClick = {handleEditClick} icon = {faPenToSquare} label = {EDIT_BUTTON_TEXT}/>
                </Grid>
                <Grid item xs = {1}>
                    {!isMobile
                        ? (
                            <ButtonWithLabel onClick = {() =>
                            {
                                dispatch( setWilmaState() );
                                dispatch( setSelectedTime( Date.now() ) );
                                dispatch( openTripLibrary() );
                                dispatch( setOpenroadsVisibilityToFalse() );
                            }} icon = {faXmark} label = {CLEAR_MAP}
                            />
                        ) : (
                            <ButtonWithLabel onClick = {() => handleDrawerClose( riskViewerStateKind, dispatch )}
                                icon = {faChevronLeft} label = {VIEW}
                            />
                        )}
                </Grid>
                <Grid item xs = {12}>
                    <RenameTripField defaultName = {tripData?.name} tripData = {tripData}/>
                    {isAdmin && isMissingRoutes &&
                    <Tooltip title = "Some variations failed to generate">
                        <WarningIcon style = {{ color: "orange", marginLeft: "8px" }}/>
                    </Tooltip>}
                </Grid>
                <Grid item xs = {12}>
                    {!isMobile && getWaypointList( tripData?.routeRequestInput?.waypoints )}
                </Grid>
            </Grid>
        </DialogTitle>
    );
};

export default TripHeader;
